import AbstractRuleTemplateModel from "./AbstractRuleTemplateModel.js";

/**
 * RuleTemplateModel to use when there is no rule template at all.
 */
export default class NoRuleTemplateModel extends AbstractRuleTemplateModel {
	constructor() {
		super(...arguments);
		// Overrides the value set by the constructor of the superclas
		// in order to save new unchaged rules.
		this._initialRuleModelData = undefined;
	}

	isNoRule() {
		return true;
	}

	ruleTemplateWidgetContentRenderer(ruleTemplateWidget) {
		return (html) => ruleTemplateWidget.renderCreateRuleTemplateOn(html);
	}

	_makeDeleteActionOn(ruleTemplatesWidget) {
		return ruleTemplatesWidget.makeNullRuleTemplateAction(
			this._ruleTemplate,
		);
	}

	_makeSaveActionOn(ruleTemplatesWidget) {
		return ruleTemplatesWidget.makeAddRuleTemplateAction(
			this._ruleTemplate,
		);
	}
}
